<ng-container *transloco="let t; read: 'user'">
  <div class="p-5">
    <h1 class="pb-2 text-3xl">{{ t('manageEnrollment.classEnrollments.pageTitle') }}</h1>
    <drdp-add-edit-table [dataSource]="dataSource" [tableData]="tableData" [columns]="tableColumns"
      (deleteActionItem)="deleteModal($event)" (editActionItem)="openModel($event)">
    </drdp-add-edit-table>
  </div>
</ng-container>
